import * as React from "react";

export default function IntroOverlay({
  onStartExit,
  onFinish,
  text = "Kika Karadi",
  textFadeInMs = 1600,
  textFadeOutMs = 1200,
  overlayFadeOutMs = 500,     // faster
  overlayFadeLagMs = 0,       // no lag
  armDelayMs = 150,
}) {
  const [textIn, setTextIn] = React.useState(false);
  const [textOut, setTextOut] = React.useState(false);
  const [overlayOut, setOverlayOut] = React.useState(false);

  const hasStartedExitRef = React.useRef(false);
  const isArmedRef = React.useRef(false);

  React.useEffect(() => {
    const armTimer = window.setTimeout(() => {
      isArmedRef.current = true;
      requestAnimationFrame(() => setTextIn(true));
    }, armDelayMs);
    return () => window.clearTimeout(armTimer);
  }, [armDelayMs]);

  const startExit = React.useCallback(() => {
    if (!isArmedRef.current) return;
    if (hasStartedExitRef.current) return;
    hasStartedExitRef.current = true;

    // 🔥 Start revealing site underneath immediately
    onStartExit?.();

    // Start exit visuals
    setTextOut(true);
    setOverlayOut(true);

    // Unmount after overlay fade completes (short)
    window.setTimeout(() => onFinish(), overlayFadeOutMs + overlayFadeLagMs);
  }, [onFinish, onStartExit, overlayFadeOutMs, overlayFadeLagMs]);

  React.useEffect(() => {
    const onWheel = () => startExit();
    const onPointerDown = () => startExit();
    const onTouchMove = () => startExit();
    const onTouchStart = () => startExit();

    window.addEventListener("wheel", onWheel, { passive: true });
    window.addEventListener("pointerdown", onPointerDown, { passive: true });
    window.addEventListener("touchstart", onTouchStart, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: true });

    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
    };
  }, [startExit]);

  return (
    <div
      className={`intro-overlay ${overlayOut ? "intro-overlay--exit" : ""}`}
      style={{
        ["--overlay-fade-ms"]: `${overlayFadeOutMs}ms`,
        ["--text-in-ms"]: `${textFadeInMs}ms`,
        ["--text-out-ms"]: `${textFadeOutMs}ms`,
      }}
    >
      <div className={`intro-overlay__text serif ${textIn ? "is-in" : ""} ${textOut ? "is-out" : ""}`}>
        {text}
      </div>
    </div>
  );
}

